<script>
import VueFeather from "vue-feather";
import DistributionClass from "@/entities/Distributions/DistributionClass";
export default {
  components: { VueFeather },
  emits: ['confirm', 'cancel'],
  props: { distribution: { type: Object } },
  setup(props, ctx) {
    const confirmEvent = () => { ctx.emit('confirm'); }
    const cancelEvent = () => { ctx.emit('cancel'); }
    return {
      confirmEvent,
      cancelEvent
    }
  },
  data() {
    return {
      inProgress: true,
      filename: '',
      visible: false
    }
  },
  methods: {
    downloadReport() {
      this.inProgress = true;
      const Distribution = new DistributionClass(this);
      Distribution.downloadReport(this.$props.distribution.id, (response) => {
        this.inProgress = false;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.filename + '.xlsx');
        document.body.appendChild(link);
        link.click();

        this.hireCancel();
      }, () => {
        this.inProgress = false;
      })
    },

    hireConfirm() {
      this.visible = false;
      setTimeout(() => {
        this.confirmEvent();
      }, 300);
    },
    hireCancel() {
      this.visible = false;
      setTimeout(() => {
        this.cancelEvent();
      }, 300);
    }
  },
  mounted() {
    this.visible = true;
    this.filename = this.$props.distribution.name;
    this.downloadReport();
  }
}
</script>

<style>
.dialog-window .modal-body { background-color: white; height: 100vh; position: relative; }
.dialog-window {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2040;
  background-color: transparent;
}
.dialog-window_background {
  background-color: rgba(0,0,15,0.6);
  width: 100%;
  height: 100%;
}
.dialog-window_body_parent {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -10vh;
  left: 0;
}
.dialog-window_body {
  display: block;
  width: 500px;
  height: fit-content;
}
.dialog-window_body .card,
.dialog-window_body .card-body {
  border-radius: 15px;
  padding: 20px 30px;
}
.dialog-window_body .card {
  border: none;
  box-shadow: none;
}
</style>

<template>
  <div class="dialog-window">
    <div class="dialog-window_background" @click="hireCancel"></div>
      <div class="dialog-window_body_parent d-flex flex-row align-items-center justify-content-center">
        <transition name="bounce">
          <div class="dialog-window_body" v-show="visible">
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-column align-items-center justify-content-start">
                <vue-feather :type="inProgress ? 'loader' : 'download'" :size="50" :class="{'rotating': inProgress}" class="tx-info mg-rem-b-4"></vue-feather>
                <h4 class="tx-center">Генерация отчета по рассылке</h4>
                <p class="tx-center">Ожидайте генерацию файла, в него будут загружен отчет по данной рассылке на текущий момент времени</p>
              </div>
            </div>
          </div>
        </div>
        </transition>
      </div>
  </div>
</template>